import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgA2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 170,
	height: 230,
	viewBox: "0 0 170 230",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6073_297)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 170,
					height: 230,
					rx: 8,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.1244 143C33.6444 143 33.2444 142.84 32.9244 142.52C32.6044 142.147 32.4444 141.747 32.4444 141.32C32.4444 141.053 32.471 140.813 32.5244 140.6L51.5644 89.16C51.7244 88.5733 52.0444 88.0667 52.5244 87.64C53.0044 87.2133 53.671 87 54.5244 87H64.7644C65.6177 87 66.2844 87.2133 66.7644 87.64C67.2444 88.0667 67.5644 88.5733 67.7244 89.16L86.7644 140.6C86.8177 140.813 86.8444 141.053 86.8444 141.32C86.8444 141.747 86.6844 142.147 86.3644 142.52C86.0444 142.84 85.6444 143 85.1644 143H76.8444C76.0444 143 75.4577 142.813 75.0844 142.44C74.711 142.067 74.471 141.72 74.3644 141.4L70.9244 132.44H48.3644L44.9244 141.4C44.8177 141.72 44.5777 142.067 44.2044 142.44C43.831 142.813 43.2444 143 42.4444 143H34.1244ZM51.3244 122.12H67.8844L59.6444 99.08L51.3244 122.12ZM93.2525 143C92.6658 143 92.1858 142.813 91.8125 142.44C91.4392 142.067 91.2525 141.587 91.2525 141V136.2C91.2525 135.773 91.3592 135.213 91.5725 134.52C91.8392 133.773 92.3992 133.053 93.2525 132.36L103.813 121.88C107.706 118.893 110.853 116.36 113.253 114.28C115.706 112.2 117.519 110.307 118.693 108.6C119.866 106.893 120.453 105.24 120.453 103.64C120.453 101.56 119.866 99.8533 118.693 98.52C117.573 97.1333 115.733 96.44 113.173 96.44C111.466 96.44 110.026 96.8133 108.853 97.56C107.733 98.2533 106.853 99.1867 106.213 100.36C105.573 101.533 105.146 102.813 104.933 104.2C104.773 104.893 104.426 105.373 103.893 105.64C103.413 105.907 102.906 106.04 102.373 106.04H93.8925C93.3592 106.04 92.9325 105.88 92.6125 105.56C92.2925 105.187 92.1325 104.787 92.1325 104.36C92.1858 101.907 92.6925 99.5867 93.6525 97.4C94.6658 95.2133 96.0792 93.2667 97.8925 91.56C99.7058 89.8533 101.893 88.52 104.453 87.56C107.013 86.5467 109.919 86.04 113.173 86.04C117.653 86.04 121.413 86.7867 124.453 88.28C127.493 89.72 129.786 91.72 131.333 94.28C132.879 96.84 133.653 99.8 133.653 103.16C133.653 105.72 133.119 108.093 132.053 110.28C131.039 112.467 129.546 114.573 127.573 116.6C125.599 118.573 123.253 120.627 120.533 122.76L111.093 132.2H132.853C133.439 132.2 133.919 132.387 134.293 132.76C134.666 133.133 134.852 133.613 134.852 134.2V141C134.852 141.587 134.666 142.067 134.293 142.44C133.919 142.813 133.439 143 132.853 143H93.2525Z",
					fill: "#27CCBC"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 166.5,
					cy: -.5,
					r: 56.5,
					fill: "#BFEFEA"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 32.5,
					cy: 216.5,
					r: 56.5,
					fill: "#BFEFEA"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 169,
			height: 229,
			rx: 7.5,
			stroke: "#BBBFC7"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6073_297",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 170,
				height: 230,
				rx: 8,
				fill: "white"
			})
		}) })
	]
});
export default SvgA2;
